/**
 * Catalog Block.
 * 
 */

/**
 * Desktop: Nothing.
 * Mobile: Adjust masking of popup background.
 */

// Adjust making of product popup background based on element dimensions.

function resizeMobilePopupPanel(extraH = 0) {
	// console.log('CATALOG: resizeMobilePopupPanel(): '+extraH);

	let
		$popContent = $('.lity-content .product-pop__content'),
		popContentH;

	// Get height of popup content (content height + top padding).
	popContentH = $popContent.height() + parseInt($popContent.css('padding-top'), 10) + extraH;
	console.log('CATALOG: popContentH: '+popContentH);
	// Set mask-size:auto 2x popup content height.
	$popContent.attr('style','mask-size:auto '+(2 * popContentH)+'px;-webkit-mask-size:auto '+(2 * popContentH)+'px');
}

function initPopupChecker() {
	// console.log('CATALOG: initPopupChecker()');

	let 
		$lityButtons = $('.catalog-block__chip-button a'),
		$lityPhotoButtons = $('a.catalog-block__chip-photo'),
		$excolButtons = $('.product-pop__model_name.ex-col-button'),
		prevExpandedCount = 0,
		prevPanelH = 0;

	// Trigger popup panel resize when product chip button is clicked.
	$lityButtons.on('click', function(event) {
		// console.log("[ LEARN MORE ] click");
		if ($(window).width() < 1024) {
			setTimeout(()=> {
				resizeMobilePopupPanel();
			}, 50);
		}
	});
	// Trigger popup panel resize when product chip photo is clicked.
	$lityPhotoButtons.on('click', function(event) {
		// console.log("[ LEARN MORE ] click");
		if ($(window).width() < 1024) {
			setTimeout(()=> {
				resizeMobilePopupPanel();
			}, 50);
		}
	});

	// Trigger popup panel resize when product model panel is clicked to expand or collapse.
	$excolButtons.on('click', function() {
		if ($(window).width() < 1024) {
			let 
				myPanelH = 0,
				$myContent = $(this).next().find('div'),
				currExpandedCount;

			// NB. Class .expanded is added/removed immediately and conditional happens after that.
			// So, on clicking an open an excol, this conditional detects it as having .expanded.
			// And on clicking to close an excol, this conditional detects it as not having .expanded.
			currExpandedCount = $('.product-pop__model_name.ex-col-button.expanded').length;
			// console.log('# expanded excols: '+currExpandedCount);
			if (currExpandedCount) {
				if ($(this).hasClass('expanded') && (currExpandedCount == prevExpandedCount)) {
					myPanelH = $myContent.height() - prevPanelH;
					prevPanelH = $myContent.height();
				} else if ($(this).hasClass('expanded')) {
					myPanelH = $myContent.height();
					prevPanelH = $myContent.height();
				} else {
					myPanelH = -$myContent.height();
					prevPanelH = $myContent.height();
				}
			} else {
				myPanelH = -$myContent.height();
				prevPanelH = $myContent.height();
			}
			prevExpandedCount = currExpandedCount;
			setTimeout(()=> {
				resizeMobilePopupPanel(myPanelH);
			}, 50);
		}
	});
}

exports.init = function () {
	// console.log('CATALOG: exports.init');
    // Run init methods...

	initPopupChecker();
};